import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { LogisticsCalculationEditableContent } from '@magimp/shared';
import { FormRow, Input } from '../../../ui/index.js';

type CargoDateTimePath = `cargos.${number}.${'departedAt' | 'arrivedAt'}`;

export function dateTimeInputToIso(value: string): string | undefined {
  if (value === '') return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
}

export function isoToDateTimeInput(value: string | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (part: number) => String(part).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function CargoDateTimeField({ name, label }: { name: CargoDateTimePath; label: string }) {
  const { t } = useTranslation('logisticsCalculations');
  const { control } = useFormContext<LogisticsCalculationEditableContent>();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormRow
          label={label}
          error={fieldState.error ? t('editor.cargo.invalidDateTime') : undefined}
        >
          <Input
            type="datetime-local"
            value={isoToDateTimeInput(typeof field.value === 'string' ? field.value : undefined)}
            onChange={(value) =>
              field.onChange(value === '' ? undefined : (dateTimeInputToIso(value) ?? value))
            }
            onBlur={field.onBlur}
            invalid={Boolean(fieldState.error)}
          />
        </FormRow>
      )}
    />
  );
}
